export const AnimatedGradientWrapper = ({ children, className = '' }) => {
  return (
    <div className={`tw-relative ${className}`}>
      <div className="tw-absolute tw-inset-0 tw-pointer-events-none tw-bg-[#fcfafb]"></div>

      {/* Contenu des enfants */}
      <div className="tw-relative tw-z-10 tw-pb-10">{children}</div>

      <style jsx>{`
        .animated-gradient {
          background: linear-gradient(-45deg, #fcfafb, #f4dada, #ffb7db, #fcfafb);
          background-size: 400% 400%;
          animation: gradientShift 15s ease infinite;
          opacity: 0.1;
        }

        @keyframes gradientShift {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
      `}</style>
    </div>
  );
};
